import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import React, { useState } from "react";
import DropdownCmp2 from "../dropdown/DropdownCmp2";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import { GetEnumsResponse } from "../../models/enum.model";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "400px",
  minHeight: "15vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

interface Props {
  open: boolean;
  setOpen: (arg: boolean) => void;
  amount: number;
  handleClose: Function;
  settlementTypes: GetEnumsResponse[];
  handleConfirm: Function;
}

const SettelmentRequestListModal = ({
  open,
  setOpen,
  amount,
  handleClose,
  settlementTypes,
  handleConfirm,
}: Props) => {
  const [settlementTypeValue, setSettlementTypeValue] = useState<number>();
  const [description, setDescription] = useState("");

  const handleSelectedTypeDrop = (e: any) => {
    setSettlementTypeValue(e.target.value);
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Grid
          container
          flexDirection={"column"}
          justifyContent={"space-between"}
          alignItems={"center"}
          gap={"30px"}
        >
          <Grid item>
            <Typography>
              آیا از{" "}
              <span style={{ fontSize: "1rem", color: "#1565C0" }}>تسویه</span>{" "}
              با مبلغ
              <span style={{ fontSize: "1rem", color: "#1565C0" }}>
                {" "}
                {amount.toLocaleString("fa")} ریال
              </span>{" "}
              اطمینان دارید؟
            </Typography>
          </Grid>
          <Grid item width={"100%"} className="dropdownCmp2-container">
            <DropdownCmp2
              style={{
                paddingRight: "0 !important",
              }}
              onChange={handleSelectedTypeDrop}
              value={settlementTypeValue}
              label={"نوع تسویه*"}
              options={settlementTypes}
              name="settlementTypeValue"
              id="settlementTypeValue"
              darkTheme={true}
            />
          </Grid>
          <Grid item width={"100%"} sx={{ paddingLeft: "0px !important" }}>
            <MaterialTextFieldComponent
              placeHolder={"توضیحات"}
              label={"توضیحات"}
              name={"description"}
              id={"description"}
              multiline
              className={"heightTextField"}
              sx={{
                "& .MuiOutlinedInput-root > .MuiInputBase-input ": {
                  fontSize: 13,
                  lineHeight: "2vh !important",
                  height: "6vh !important",
                },
                "& .MuiInputBase-root": {
                  height: "14vh !important",
                },
              }}
              onChange={(e: any) => {
                if (description.length > 250) {
                  e.preventDefault();
                } else {
                  setDescription(e.target.value);
                }
              }}
              value={description}
            />
          </Grid>
          <Grid item width={"100%"}>
            <Grid
              container
              justifyContent={"center"}
              alignItems={"center"}
              marginBottom={"8px"}
            >
              <Grid item xs={6} width={"100%"} sx={{ paddingInline: "10px" }}>
                <Button
                  fullWidth
                  variant="contained"
                  disabled={!settlementTypeValue}
                  className={
                    !settlementTypeValue
                      ? "btnForm disabledBtn"
                      : "btnForm SuccessDefault"
                  }
                  onClick={() =>
                    handleConfirm(description, settlementTypeValue)
                  }
                >
                  تایید و ادامه
                </Button>
              </Grid>
              <Grid item xs={6} width={"100%"} sx={{ paddingInline: "10px" }}>
                <Button
                  onClick={() => {
                    setSettlementTypeValue(undefined);
                    setDescription("");
                    handleClose();
                  }}
                  fullWidth
                  variant="contained"
                  style={{
                    fontSize: "1rem",
                    color: "#fff",
                    height: "40px",
                    background: "#607D8B",
                  }}
                >
                  بازگشت
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default SettelmentRequestListModal;
